export default "__VITE_ASSET__e3b228c8__"